<template>
	<v-dialog
		v-model="dialog"
		max-width="500"
	>
		<template #activator="{ props }">
			<v-btn
				variant="plain"
				class="text-none pl-1 pr-1"
				v-bind="props"
			>
				<v-icon
					color="primary"
					icon="$info"
				/>
				<translate>How do I find the EAN number?</translate>
			</v-btn>
		</template>

		<v-card>
			<v-card-title>
				<translate>
					EAN
				</translate>
			</v-card-title>
			<v-card-text>
				<v-list>
					<v-list-subheader>
						<translate>How do I find the EAN number?</translate>
					</v-list-subheader>
					<v-list-item
						v-for="(item, i) in eanList"
						:key="i"
					>
						{{ item.text }}
					</v-list-item>
				</v-list>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="primary"
					@click="dialog=false"
				>
					<translate>Okay</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'EanInfoDialog',

	data () {
		return {
			dialog: false
		};
	},

	computed: {
		eanList () {
			return [
				{
					text: this.$gettext('You can find the EAN number on the packaging of your product. It ' +
						'will always consist of 13 numbers, and it does not contain any letters.')
				},
			];
		}
	}

};
</script>
